module.exports = __webpack_public_path__ + "static/media/landing-transfer.bd727508.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/landing-transfer.png
// module id = 656
// module chunks = 8